"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _debug = _interopRequireDefault(require("debug"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Spinner = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Spinner"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _paths = require("../../utils/paths");
var _ErrorBoundary = _interopRequireDefault(require("../ErrorBoundary"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = {
  "documentation-panel": "APIDocumentation__documentation-panel__3M0GO",
  "documentationPanel": "APIDocumentation__documentation-panel__3M0GO",
  "spinner": "APIDocumentation__spinner__2Hm1A",
  "title": "APIDocumentation__title__2dxMs",
  "hidden": "APIDocumentation__hidden__1b0x1"
}; 
require('./APIDocumentation.css');
var log = (0, _debug.default)('apiconsole:components:apidocumentation');
var APIDocumentation = exports.default = /*#__PURE__*/function (_Component) {
  function APIDocumentation() {
    var _this;
    (0, _classCallCheck2.default)(this, APIDocumentation);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, APIDocumentation, [].concat(args));
    (0, _defineProperty2.default)(_this, "handleAPINavigationSelectionChangedEvent", function (event) {
      var _event$detail = event.detail,
        passive = _event$detail.passive,
        selected = _event$detail.selected,
        type = _event$detail.type;
      event.preventDefault();
      log('handleAPINavigationSelectionChangedEvent', event.detail);
      if (selected && type && !passive) {
        _this.handleSelectionChanged(selected, type);
      }
    });
    (0, _defineProperty2.default)(_this, "handleSelectionChanged", function (selected, nodeType) {
      if (_this.props.onSelectionChanged) {
        _this.props.onSelectionChanged(selected, nodeType);
        return;
      }
      var _this$context = _this.context,
        getPath = _this$context.getPath,
        push = _this$context.push;
      var _this$props = _this.props,
        asset = _this$props.asset,
        isDraft = _this$props.isDraft,
        isVersionNavigation = _this$props.isVersionNavigation;
      var type = asset.type,
        groupId = asset.groupId,
        assetId = asset.assetId,
        version = asset.version,
        minorVersion = asset.minorVersion,
        organization = asset.organization;
      var consolePath = getPath('console', {
        type: type,
        groupId: groupId,
        assetId: assetId,
        version: version,
        minorVersion: minorVersion,
        organization: organization,
        consolePath: (0, _paths.getConsolePathForSelection)(nodeType, selected),
        isDraft: isDraft,
        isVersionNavigation: isVersionNavigation
      });
      push(consolePath);
    });
    (0, _defineProperty2.default)(_this, "handleTryItRequested", function (event) {
      var id = event.detail.id;
      event.preventDefault();
      event.stopPropagation();
      log('handleTryItRequested', event.detail);
      if (id) {
        _this.handleSelectionChanged(id, 'method');
      }
    });
    return _this;
  }
  (0, _inherits2.default)(APIDocumentation, _Component);
  return (0, _createClass2.default)(APIDocumentation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        selected = _this$props2.selected,
        selectedType = _this$props2.selectedType,
        amfModel = _this$props2.amfModel;
      if (selected) {
        this.apiDocumentationElement.selected = selected;
      }
      if (selectedType) {
        this.apiDocumentationElement.selectedType = selectedType;
      }
      if (amfModel) {
        this.apiDocumentationElement.amfModel = amfModel;
        this.apiDocumentationElement.amf = amfModel;
      }
      /**
       * This is quite important in terms of navigation in the endpoint
       * documentation panel. Update this to an element that keeps scroll content.
       * Usually it is window object but it might be something else.
       */
      this.apiDocumentationElement.scrollTarget = global;
      this.apiDocumentationElement.addEventListener('api-navigation-selection-changed', this.handleAPINavigationSelectionChangedEvent);
      this.apiDocumentationElement.addEventListener('tryit-requested', this.handleTryItRequested);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
        selected = _this$props3.selected,
        selectedType = _this$props3.selectedType,
        amfModel = _this$props3.amfModel;
      if (selected && prevProps.selected !== selected) {
        this.apiDocumentationElement.selected = selected;
      }
      if (selectedType && prevProps.selectedType !== selectedType) {
        this.apiDocumentationElement.selectedType = selectedType;
      }
      if (amfModel && prevProps.amfModel !== amfModel) {
        this.apiDocumentationElement.amfModel = amfModel;
        this.apiDocumentationElement.amf = amfModel;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.apiDocumentationElement.removeEventListener('api-navigation-selection-changed', this.handleAPINavigationSelectionChangedEvent);
      this.apiDocumentationElement.removeEventListener('tryit-requested', this.handleTryItRequested);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        amfModel = _this$props4.amfModel,
        selectedType = _this$props4.selectedType;
      return /*#__PURE__*/_react.default.createElement("section", {
        "aria-label": "API documentation"
      }, selectedType === 'summary' ? /*#__PURE__*/_react.default.createElement("h2", {
        "data-test-id": "api-summary"
      }, "API specification summary") : null, this.props.isLoading ? /*#__PURE__*/_react.default.createElement(_Spinner.default, {
        "data-test-id": "raml-documentation-panel-spinner",
        className: styles.spinner,
        center: true,
        size: "l"
      }) : null, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)((0, _defineProperty2.default)({}, styles.hidden, !amfModel))
      }, /*#__PURE__*/_react.default.createElement(_ErrorBoundary.default, {
        message: "We can't load the documentation"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "apic-container"
      }, /*#__PURE__*/_react.default.createElement("api-documentation", {
        compatibility: true,
        noTryIt: true,
        noServerSelector: true,
        ref: function ref(element) {
          _this2.apiDocumentationElement = element;
        }
      })))));
    }
  }]);
}(_react.Component);
(0, _defineProperty2.default)(APIDocumentation, "propTypes", {
  asset: _propTypes.default.any,
  isDraft: _propTypes.default.bool,
  isLoading: _propTypes.default.bool,
  isVersionNavigation: _propTypes.default.bool,
  amfModel: _propTypes.default.array,
  onSelectionChanged: _propTypes.default.func,
  selected: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
  selectedType: _propTypes.default.string
});
(0, _defineProperty2.default)(APIDocumentation, "contextType", _exchangeReactHooks.RouterContext);
//# sourceMappingURL=APIDocumentation.js.map